import React from 'react';
import MealPage from './MealPage';
import { colors } from '../theme';
import { MEAL_LABELS } from '../constants/mealLabels';

const SnacksPage = () => (
  <MealPage mealtime="snacks" title={MEAL_LABELS.snacks} accentColor={colors.meal.snacks} />
);

export default SnacksPage;
